import { render, staticRenderFns } from "./GiftCardPhone.vue?vue&type=template&id=4c3efe8e&"
import script from "./GiftCardPhone.vue?vue&type=script&lang=js&"
export * from "./GiftCardPhone.vue?vue&type=script&lang=js&"
import style0 from "./GiftCardPhone.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports